import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../productPageStyle.js";
import SectionHead from "./SectionHead.js";

const useStyles = makeStyles(styles);

/**
 * A plain INCI list. No score colouring, no legend, no "notable ingredient"
 * highlights: those are assessments of individual ingredients, and B-01 §7 says
 * the mark certifies no such thing (§26.2 calls reading more into it
 * "kiterjesztő értelmezés").
 *
 * The names are set as one running line rather than a numbered list on
 * purpose — numbering the manufacturer's declared order would read as a rank,
 * which is precisely what the note below the list denies.
 */
export default function IngredientsSection({ t, product, num }) {
  const classes = useStyles();
  const [copied, setCopied] = useState(false);
  const timerRef = useRef(null);
  const ingredients = product.ingredients || [];

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  if (ingredients.length === 0) return null;

  const inciText = ingredients.map((i) => i.inci).join(", ");

  const copy = () => {
    if (!navigator.clipboard) return;
    navigator.clipboard.writeText(inciText).then(
      () => {
        setCopied(true);
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => setCopied(false), 1500);
      },
      () => {
        // Clipboard rejected (permission denied, insecure context).
      }
    );
  };

  return (
    <section id="section-ingredients" className={classes.section}>
      <SectionHead
        num={num}
        title={t.ingTitle}
        aside={`${ingredients.length} ${t.ingCount}`}
      />
      <div className={classes.sectionBody}>
        <p className={classes.inciList}>{inciText}</p>
        <div className={classes.inciFooter}>
          <button type="button" className={classes.copyButton} onClick={copy}>
            <svg
              className={classes.copyIcon}
              width="13"
              height="13"
              viewBox="0 0 16 16"
              fill="none"
              aria-hidden="true"
            >
              <rect
                x="5.5"
                y="5.5"
                width="9"
                height="9"
                rx="1.5"
                stroke="currentColor"
                strokeWidth="1.4"
              />
              <path
                d="M10.5 3.5v-1a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h1"
                stroke="currentColor"
                strokeWidth="1.4"
                strokeLinecap="round"
              />
            </svg>
            {copied ? t.ingCopied : t.ingCopy}
          </button>
          <p className={classes.inciNote}>{t.ingNote}</p>
        </div>
      </div>
    </section>
  );
}
